module.exports = "/assets/66a7fcdb18cb66ddf98ef92e68eefba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CD.png
// module id = 2389
// module chunks = 0